
import { Component, Vue, Prop } from 'vue-property-decorator';

import StepCompletedCheckbox from './StepCompletedCheckbox.vue';
import GavelIconSvg from '@/iconSVG/GavelIconSvg.vue'
import GavelIconSvgChecked from '@/iconSVG/GavelIconSvgChecked.vue'

@Component({
    components:{
        StepCompletedCheckbox,
        GavelIconSvg,
        GavelIconSvgChecked
    }
})

export default class GavelIcon extends Vue {


    @Prop({required: false})
    active!: boolean;

    @Prop({required: false})
    status!: string;

    @Prop({required: false})
    stepTitleOptional!: string;

    @Prop({required: true})
    stepTitle!: string;  

    @Prop({required: false})
    ready!: boolean;

    @Prop({required: true})
    order!: number;    

    @Prop({required: false})
    stepTitleClass!: string;

    public action(){
        this.$emit('action')
    }
    public completed(checked) {
        this.$emit('completed', this.order-1, checked)
    }

}
